import { DEMO_CUSTOMER } from 'customer-flows/demo/customer'

export default function demoHydrateCustomer({ stores }: CommandArgs) {
  const customerStore: CustomerStore = stores['customer']

  function hydrate(): boolean {
    if (customerStore.name || customerStore.email || customerStore.phone) return false

    customerStore.name = DEMO_CUSTOMER.name
    customerStore.email = DEMO_CUSTOMER.email
    customerStore.phone = DEMO_CUSTOMER.phone

    return true
  }

  return { hydrate }
}
